import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../config/axios';
import { formatError } from '../utils/errorHandler';
import { formatDateTime } from '../utils/locale';
import './TaskBillingStatusSection.css';

function TaskBillingStatusSection({ task, onUpdated }) {
  const { t, i18n } = useTranslation(['tasks', 'common']);
  const [saving, setSaving] = useState(null);
  const [error, setError] = useState('');

  if (!task) {
    return null;
  }

  const toggle = async (field, nextValue) => {
    setSaving(field);
    setError('');
    try {
      const response = await axios.patch(`/api/tasks/${task.id}/billing-status`, {
        [field]: nextValue
      });
      const data = response.data?.data || {};
      if (typeof onUpdated === 'function') {
        onUpdated({
          attested: data.attested,
          attested_by: data.attested_by,
          attested_at: data.attested_at,
          attested_by_name: data.attested_by_name,
          invoiced: data.invoiced,
          invoiced_by: data.invoiced_by,
          invoiced_at: data.invoiced_at,
          invoiced_by_name: data.invoiced_by_name
        });
      }
    } catch (err) {
      setError(formatError(err) || t('tasks:billingStatusUpdateFailed'));
    } finally {
      setSaving(null);
    }
  };

  const attestedMeta = task.attested && task.attested_at
    ? t('tasks:billingMarkedBy', {
      name: task.attested_by_name || t('tasks:unknownSubmitter'),
      datetime: formatDateTime(task.attested_at, i18n.language)
    })
    : null;

  const invoicedMeta = task.invoiced && task.invoiced_at
    ? t('tasks:billingMarkedBy', {
      name: task.invoiced_by_name || t('tasks:unknownSubmitter'),
      datetime: formatDateTime(task.invoiced_at, i18n.language)
    })
    : null;

  return (
    <div className="task-billing-status">
      <h3 className="task-section-label">{t('tasks:billingStatusTitle')}</h3>
      <p className="task-billing-status-description">{t('tasks:billingStatusDescription')}</p>

      {error && <div className="error task-billing-status-error">{error}</div>}

      <div className="task-billing-status-rows">
        <label className="task-billing-status-row">
          <input
            type="checkbox"
            checked={Boolean(task.attested)}
            disabled={Boolean(saving)}
            onChange={(e) => toggle('attested', e.target.checked)}
          />
          <span className="task-billing-status-row-text">
            <span className="task-billing-status-row-label">{t('tasks:billingAttested')}</span>
            {attestedMeta && (
              <span className="task-billing-status-row-meta">{attestedMeta}</span>
            )}
          </span>
        </label>

        <label className="task-billing-status-row">
          <input
            type="checkbox"
            checked={Boolean(task.invoiced)}
            disabled={Boolean(saving)}
            onChange={(e) => toggle('invoiced', e.target.checked)}
          />
          <span className="task-billing-status-row-text">
            <span className="task-billing-status-row-label">{t('tasks:billingInvoiced')}</span>
            {invoicedMeta && (
              <span className="task-billing-status-row-meta">{invoicedMeta}</span>
            )}
          </span>
        </label>
      </div>
    </div>
  );
}

export default TaskBillingStatusSection;
